const GannFanIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28">
            <g fill="currentColor" fillRule="nonzero">
                <path d="M7.354 21.354l7.097-7.097-.707-.707-7.097 7.097z"></path>
                <path d="M17.249 11.458l7.105-7.105-.707-.707-7.105 7.105z"></path>
                <path d="M7.542 22.683l17.296-2.739-.156-.988-17.296 2.739z" id="Line"></path>
                <path d="M7.538 22.062l15.708-7.661-.438-.899-15.708 7.661z"></path>
                <path d="M6.802 20.97l7.695-15.777-.899-.438-7.695 15.777z"></path>
                <path d="M6.285 20.741l2.76-17.423-.988-.156-2.76 17.423z"></path>
                <path d="M5.5 24c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5-1.5.672-1.5 1.5.672 1.5 1.5 1.5zm0 1c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5zM15.5 14c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5-1.5.672-1.5 1.5.672 1.5 1.5 1.5zm0 1c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5z"></path>
            </g>
        </svg>
    )
}
export default GannFanIcon